/**
 * 主页快捷导航
 * 前端官网快捷导航
 */
export const siteData = [
  {
    name: "HarmonyOS",
    desc: "鸿蒙原生应用,移动应用生态的历史性跨越",
    link: "https://developer.huawei.com/consumer/cn/",
    className: "color-green-gradient1",
  },
  {
    name: "Vue3",
    desc: "易学易用，性能出色，适用场景丰富的 Web 前端框架",
    link: "https://cn.vuejs.org/",
    className: "color-green-gradient2",
  },
  {
    name: "Element Plus",
    desc: "基于 Vue 3，面向设计师和开发者的组件库",
    link: "https://element-plus.org/zh-CN/",
    className: "color-green-gradient3",
  },
  {
    name: "Pinia",
    desc: "符合直觉的 Vue.js 状态管理库",
    link: "https://pinia.vuejs.org/zh/",
    className: "color-red",
  },
  {
    name: "React",
    desc: "用于构建 Web 和原生用户界面的库",
    link: "https://react.nodejs.cn/",
    className: "color-pink1",
  },
  {
    name: "Ant Design",
    desc: "一个 UI 设计语言，蚂蚁金服体验技术部出品",
    link: "https://ant-design.antgroup.com/index-cn",
    className: "color-blue-light6",
  },
  {
    name: "Vite",
    desc: "下一代前端开发与构建工具",
    link: "https://cn.vitejs.dev/",
    className: "color-blue-deep4",
  },
  {
    name: "TypeScript",
    desc: "TypeScript由微软开源的编程语言，它是 JavaScript 的一个超集，而且本质上向这个语言添加了可选的静态类型和基于类的面向对象编程。",
    link: "https://ts.nodejs.cn/",
    className: "color-green-gradient3",
  },
  {
    name: "Vitest",
    desc: "由 Vite 提供支持的极速单元测试框架",
    link: "https://cn.vitest.dev/",
    className: "color-green-gradient1",
  },
];
